export default {
  Profile: 'Perfil',
  'Save profile': 'Guardar perfil',

  mobile: {
    'Please enter a code': 'Please enter a code',
  },
};
